import { defineStore } from 'pinia'
import { ChoiceApi } from '../../LibMain';
import { FeatureType, ProductType } from '../../Enums/ChoiceEnums';
import { ErrorCallbackFunction } from '../ChoiceApi';

export const useCompanySettingsStore = defineStore('CompanySettingsStore', () => {
    const productActiveDict: Record<ProductType|number, boolean|undefined> = {};
    const featureEnabledDict: Record<FeatureType|string, boolean|undefined> = {};

    // Is a product active for this database
    async function isProductActive(productType: ProductType, errorCallback?: ErrorCallbackFunction): Promise<boolean | undefined>
    {
        // Return cached value?
        if (undefined == productActiveDict[productType])
        {
            // Fetch value
            productActiveDict[productType] = await ChoiceApi.companySettings.isProductActive(productType, errorCallback);
        }
        return productActiveDict[productType]
    }

    // Is a feature enabled for this database
    async function isFeatureEnabled(groupName:FeatureType|string, errorCallback?: ErrorCallbackFunction): Promise<boolean | undefined> 
    {
        if (undefined == featureEnabledDict[groupName])
        {
            // Fetch value
            featureEnabledDict[groupName] = await ChoiceApi.company.isFeatureEnabled(groupName, errorCallback);
        }
        return featureEnabledDict[groupName];
    }

    return { productActiveDict, featureEnabledDict, isProductActive, isFeatureEnabled };
});
